import misc from './misc';

const { getEmailQuery, buildTestEmail } = misc;

export default {
  mentorApproved: {
    title: 'Internal Mobility » Mentor is Approved',
    description: 'Sent to mentors after an admin approves their profile',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imMentorApprovedEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_APPROVED_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_APPROVED_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_APPROVED_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/mentor-approved', {
      template_subject: 'template.EMAIL_IM_MENTOR_APPROVED_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_MENTOR_APPROVED_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_MENTOR_APPROVED_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imMentorApprovedEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_MENTOR_APPROVED_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_MENTOR_APPROVED_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_MENTOR_APPROVED_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland'
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  mentorNewRequest: {
    title: 'Internal Mobility » New Mentor Request',
    description: 'Sent to mentors after an employee contacts them through the platform',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imMentorNewRequestEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_NEW_REQUEST_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_NEW_REQUEST_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_NEW_REQUEST_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/mentor-new-request', {
      template_subject: 'template.EMAIL_IM_MENTOR_NEW_REQUEST_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_MENTOR_NEW_REQUEST_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_MENTOR_NEW_REQUEST_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imMentorNewRequestEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_MENTOR_NEW_REQUEST_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_MENTOR_NEW_REQUEST_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_MENTOR_NEW_REQUEST_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
          menteeRequest: {
            id: 'testid',
            user: {
              id: 'testid',
              fullName: 'John Doe',
            },
            message: 'I would love to become a Software Engineer. I believer you\'re the perfect mentor to help me achieving it.',
            skills: [ 'JavaScript', 'SQL', 'NodeJS' ],
          },
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  mentorRejected: {
    title: 'Internal Mobility » Mentor Declined',
    description: 'Sent to mentors admin declines their request to be an active mentor',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imMentorRejectedEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REJECTED_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REJECTED_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REJECTED_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/mentor-rejected', {
      template_subject: 'template.EMAIL_IM_MENTOR_REJECTED_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_MENTOR_REJECTED_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_MENTOR_REJECTED_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imMentorRejectedEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_MENTOR_REJECTED_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_MENTOR_REJECTED_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_MENTOR_REJECTED_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  mentorStatusChanged: {
    title: 'Internal Mobility » Mentor Status Changed',
    description: 'Sent to mentors after their status is changed to ACTIVE or INACTIVE',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imMentorStatusChangedEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_STATUS_CHANGED_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_STATUS_CHANGED_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/mentor-status-changed', {
      template_subject: 'template.EMAIL_IM_MENTOR_STATUS_CHANGED_SUBJECT',
      template_plainHTML: 'template.EMAIL_IM_MENTOR_STATUS_CHANGED_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imMentorStatusChangedEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_MENTOR_STATUS_CHANGED_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_MENTOR_STATUS_CHANGED_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
          mentorStatus: 'ACTIVE',
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  mentorRequestApproved: {
    title: 'Internal Mobility » Mentor Request Approved',
    description: 'Sent to both mentor and mentee after mentor request is approved by mentor',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imMentorRequestApprovedEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REQUEST_APPROVED_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REQUEST_APPROVED_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REQUEST_APPROVED_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/mentor-request-approved', {
      template_subject: 'template.EMAIL_IM_MENTOR_REQUEST_APPROVED_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_MENTOR_REQUEST_APPROVED_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_MENTOR_REQUEST_APPROVED_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imMentorRequestApprovedEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_MENTOR_REQUEST_APPROVED_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_MENTOR_REQUEST_APPROVED_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_MENTOR_REQUEST_APPROVED_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
          mentorRequest: {
            id: 'testid',
            user: {
              id: 'testid',
              fullName: 'John Doe',
              emailAddress: 'john.doe@email.com'
            },
            mentor: {
              id: 'testid2',
              fullName: 'Miley McMiland',
              emailAddress: 'miley.mcmiland@email.com'
            },
            message: 'I would love to become a Software Engineer. I believer you\'re the perfect mentor to help me achieving it.',
            skills: [ 'JavaScript', 'SQL', 'NodeJS' ],
          },
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  mentorRequestRejected: {
    title: 'Internal Mobility » Mentor Request Rejected',
    description: 'Sent to mentee after mentor request is rejected by mentor',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imMentorRequestRejectedEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REQUEST_REJECTED_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REQUEST_REJECTED_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_MENTOR_REQUEST_REJECTED_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/mentor-request-rejected', {
      template_subject: 'template.EMAIL_IM_MENTOR_REQUEST_REJECTED_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_MENTOR_REQUEST_REJECTED_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_MENTOR_REQUEST_REJECTED_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        imMentorRequestRejectedEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_MENTOR_REQUEST_REJECTED_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_MENTOR_REQUEST_REJECTED_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_MENTOR_REQUEST_REJECTED_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
          mentorRequest: {
            mentor: {
              id: 'testid2',
              fullName: 'Miley McMiland',
            },
          },
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  isMentorshipActive: {
    title: 'Internal Mobility » Is your mentorship active?',
    description: 'Sent to both mentor and mentee 7 days after the mentor request was initiated.',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      // {
      //   title: 'Plain Text Email',
      //   key: 'plain-text-email',
      // }
    ],
    fields: [
      // {
      //   key: 'preferences.imIsYourMentorshipStillActiveEmailPlain',
      //   label: 'Use plain text email',
      //   description: 'Send plain text email as defined under the plain text email tab',
      //   type: 'boolean',
      // },
      {
        key: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/is-your-mentorship-active', {
      template_subject: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        # imIsYourMentorshipActiveEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_IS_YOUR_MENTORSHIP_ACTIVE_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
          mentorRequest: {
            id: 'testid',
            user: {
              id: 'testid',
              fullName: 'John Doe',
              emailAddress: 'john.doe@email.com'
            },
            mentor: {
              id: 'testid2',
              fullName: 'Miley McMiland',
              emailAddress: 'miley.mcmiland@email.com'
            },
            message: 'I would love to become a Software Engineer. I believer you\'re the perfect mentor to help me achieving it.',
            skills: [ 'JavaScript', 'SQL', 'NodeJS' ],
          },
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
  isMentorshipStillActive: {
    title: 'Internal Mobility » Is your mentorship still active?',
    description: 'Sent to both mentor and mentee 2 months after mentorship started.',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      // {
      //   title: 'Plain Text Email',
      //   key: 'plain-text-email',
      // }
    ],
    fields: [
      // {
      //   key: 'preferences.imIsYourMentorshipStillActiveEmailPlain',
      //   label: 'Use plain text email',
      //   description: 'Send plain text email as defined under the plain text email tab',
      //   type: 'boolean',
      // },
      {
        key: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('internal-mobility/is-your-mentorship-still-active', {
      template_subject: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_SUBJECT',
      template_bodyOne: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        emailHideBrandLogo
        canSyncContacts
        # imIsYourMentorshipStillActiveEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_IS_YOUR_MENTORSHIP_STILL_ACTIVE_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        user: {
          firstName: 'Miley',
          fullName: 'Miley McMiland',
          mentorRequest: {
            id: 'testid',
            user: {
              id: 'testid',
              fullName: 'John Doe',
              emailAddress: 'john.doe@email.com'
            },
            mentor: {
              id: 'testid2',
              fullName: 'Miley McMiland',
              emailAddress: 'miley.mcmiland@email.com'
            },
            message: 'I would love to become a Software Engineer. I believer you\'re the perfect mentor to help me achieving it.',
            skills: [ 'JavaScript', 'SQL', 'NodeJS' ],
          },
        },
      };
      return {
        ...result,
        user: {
          ...result.user,
          ...fakeData.user,
        },
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/emails/previews/mentorEmails.js